(function () {
    if (window.location.pathname !== '/long-term-hire/apply') return;

    $('#title').selectize();

    $.get('/static/datasets/countries', function (countries) {
        $('#country, #country-of-interest').selectize({
            valueField: 'code',
            labelField: 'name',
            searchField: 'name',
            sortField: 'name',
            selectOnTab: true,
            options: countries,
        });
    });

    $('#location').selectize();
    $('#contact_preference').selectize();
    $('#excess').selectize();
})();
